import { api } from '@/shared/services/api';

export interface CaenCode {
  id: string;
  revision: 'rev2' | 'rev3';
  code: string;
  level: 'section' | 'division' | 'group' | 'class';
  parentCode: string | null;
  label: string;
  include: string | null;
  includeAlso: string | null;
  exclude: string | null;
  createdAt: string;
}

export interface CaenMigration {
  rev2: { code: string; label: string };
  targets: Array<{
    code: string;
    label: string | null;
    mappingType: 'identical' | 'split' | 'merge' | 'renamed' | 'new';
    notes: string | null;
  }>;
}

export const caenApi = {
  search: (params: { q?: string; revision?: 'rev2' | 'rev3'; level?: string; parent?: string; limit?: number }) => {
    const qs = new URLSearchParams();
    if (params.q) qs.set('q', params.q);
    if (params.revision) qs.set('revision', params.revision);
    if (params.level) qs.set('level', params.level);
    if (params.parent) qs.set('parent', params.parent);
    if (params.limit) qs.set('limit', String(params.limit));
    return api.get<CaenCode[]>(`/caen-codes?${qs.toString()}`);
  },

  byCode: (code: string, revision: 'rev2' | 'rev3' = 'rev3') =>
    api.get<CaenCode>(`/caen-codes/${code}?revision=${revision}`),

  migrate: (rev2Code: string) =>
    api.get<CaenMigration>(`/caen-codes/migrate/${rev2Code}`),
};


export type PrimaryActivityType = 'services' | 'goods' | 'mixt';

/**
 * Client-side classifier — mirror al backend-ului din caen-classifier.ts.
 * Folosit pentru preview live: cand user schimba codul CAEN, sugerez tipul
 * de activitate înainte de a salva.
 */
export function classifyCaenCode(code: string | null | undefined): PrimaryActivityType | null {
  if (!code) return null;
  const trimmed = String(code).trim();
  if (trimmed.length < 2) return null;
  const div = parseInt(trimmed.substring(0, 2), 10);
  if (isNaN(div)) return null;
  // Manufacturing (10-33) + Retail (45-47) → marfă cu stoc
  if ((div >= 10 && div <= 33) || (div >= 45 && div <= 47)) return 'goods';
  // Agri/Mining (01-09), Energy/Construction (35-43), Transport/HoReCa (49-56) → mixt
  if ((div >= 1 && div <= 9) || (div >= 35 && div <= 43) || (div >= 49 && div <= 56)) return 'mixt';
  // J-V (58+) → servicii
  return 'services';
}

export const ACTIVITY_TYPE_LABELS: Record<PrimaryActivityType, string> = {
  services: 'Servicii',
  goods: 'Comerț cu marfă (stoc)',
  mixt: 'Mixt (servicii + marfă)',
};
